module.exports = "/images/bq-se.svg?86146fa6435b1109c688c574936b7c91";